<template>
    <div>
        <div class=" mb-5">
            <!-- shape Hero -->
            <section class="section-shaped my-0 pb-lg-5">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div class="container shape-container d-flex">
                    <div class="col px-0">
                        <div class="row">
                            <div class="col-lg-6">
                                <h1 class="display-3  ">Welcome Back
                                </h1>
                                <p>We have missed you.</p>
                            </div>
                            <div class="col-lg-6">
                                <div v-if="errorMessage != null" id="errorNotification">
                                    <base-alert type="danger">
                                        <span class="alert-inner--text"> {{errorMessage}}</span>
                                    </base-alert>
                                </div>
                                <div class="card bg-white p-4">
                                    <h2>Login</h2>
                                    <base-input alternative="" label="Email" type="email" v-model="email" placeholder="Email" input-classes="form-control" required />
                                    <base-input alternative="" label="Password" type="password" v-model="password" placeholder="Password" input-classes="form-control" required @keyup.enter="login"/>
                                    <a-button type="primary" class="btn btn-primary btn-large" size="large" :loading="loginLoading" @click.prevent="login">
                                        LOGIN
                                    </a-button>
                                    <p class="text-center mt-3"> OR </p>
                                    <div class="btn-wrapper text-center w-100 mb-3">
                                        <v-facebook-login app-id="3199557610083038" @sdk-init="handleSdkInit" class="d-none" @login="FBLogin" />
                                        <a type="button" class="btn btn-neutral border btn-icon" @click.prevent="scope.login" style="width: 48%;">
                                            <span class="btn-inner--icon"><img src="https://upload.wikimedia.org/wikipedia/commons/f/ff/Facebook_logo_36x36.svg"></span>
                                            <span class="btn-inner--text">Facebook</span>
                                        </a>
                                        <GoogleLogin :params="googleParams" class="btn btn-neutral border btn-icon" style="width: 48%;" :onSuccess="onSuccess" :onFailure="onFailure">
                                            <span class="btn-inner--icon"><img src="https://demos.creative-tim.com/argon-dashboard/assets/img/icons/common/google.svg"></span>
                                            <span class="btn-inner--text">Google</span>
                                        </GoogleLogin>
                                    </div>
                                    <a class="login-form-forgot" href="">
                                        Forgot password
                                    </a>
                                    <router-link :to="{ name: 'customer_register', params: { storeName: this.$route.params.storeName, accountName: this.$route.params.accountName }}"
                                                >
                                        REGISTER NOW!
                                    </router-link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
    </div>
</template>
<script>
import secureStorage from '../../controllers/secureStorage.js'
import HTTPRequest from '../../controllers/httpRequest.js'
import GoogleLogin from 'vue-google-login'
import VFacebookLogin from 'vue-facebook-login-component'
import { mapState, mapActions } from 'vuex'
                            
var component_x
export default {
    components: {
        HTTPRequest,
        GoogleLogin,
        VFacebookLogin
    },
    computed: {
        ...mapState(['endPoint', 'parameters'])
    },
    data() {
        return {
            email:null,
            password:null,
            errorMessage:null,
            loginLoading:false,
            googleParams: {
                client_id: "609424787778-eh50vspe8o92o306gooto8sfjgv1i52g.apps.googleusercontent.com",
            },
            FB: {},
            model: {},
            scope: {},
            salesChannelId:null,
            storeDetails:{},
        }
    },
    mounted: async function(){
        var autoLogin = secureStorage.getItem("ecomLoggedIn")
        if(autoLogin == true){
            component_x = this
            this.salesChannelId = secureStorage.getItem("SalesChannelDetails").id
            this.storeDetails = secureStorage.getItem("SalesChannelDetails")
            this.$emit('showFooterAndHeader', event)
            this.$emit('hideSearchInput', event)
            if (secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerLoginStatus") == true){
                this.$router.push({ name: 'store',params:{ storeId:this.$route.params.storeId }})
            }
        }else{
            this.$router.push({ name: 'loading_screen', params: { returnUrl: 'customer_login' }})
        }
    },
    methods:{
        login: async function(){
            this.errorMessage = null;
            if(this.email == null || this.password == null || this.email == '' || this.password == ''){
                this.errorMessage = "Email and password are both required fields for login."
            } else {
                this.loginLoading = true
                var login_payload = {email: this.email, password: this.password}
                var customer_account = await HTTPRequest.postRequest(this.endPoint + 'sales_channel_customers/login?account_id='+this.storeDetails.account_id, null, login_payload)
                console.log(customer_account)
                if (customer_account.error){
                    this.errorMessage = customer_account.error
                    this.loginLoading = false
                } else {
                    secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin",customer_account)
                    secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerLoginStatus",true)
                    this.$notification['info']({
                        message: 'Welcome back ' + customer_account.name+ '!',
                        description: "",
                        style: { zIndex: 100000 }
                    });
                    this.$emit('checkLoginStatus', event)
                    this.loginLoading = false
                    if(this.$route.params.returnUrl!=null){
                        this.$router.push({ name: this.$route.params.returnUrl,params:{ storeId:this.$route.params.storeId }})
                    }else{
                        this.$router.push({ name: 'store',params:{ storeId:this.$route.params.storeId }})
                    }
                }
            }
        },
        onSuccess: async function(googleUser) {
            console.log(googleUser.getBasicProfile())
            this.errorMessage = null;
            var login_payload = {email: googleUser.getBasicProfile().getEmail()}
            var customer_account = await HTTPRequest.postRequest(this.endPoint + 'sales_channel_customers/login_using_gmail_or_facebook?account_id='+this.storeDetails.account_id, null, login_payload)
            console.log(customer_account)
            if (customer_account.error){
                this.errorMessage = customer_account.error
                this.loginLoading = false
            } else {
                secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin",customer_account)
                secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerLoginStatus",true)
                secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-gmailStatus",true)
                this.$notification['info']({
                    message: 'Welcome back ' + customer_account.name+ '!',
                    description: "",
                    style: { zIndex: 100000 }
                });
                this.$emit('checkLoginStatus', event)
                this.loginLoading = false
                if(this.$route.params.returnUrl!=null){
                    this.$router.push({ name: this.$route.params.returnUrl,params:{ storeId:this.$route.params.storeId }})
                }else{
                    this.$router.push({ name: 'store',params:{ storeId:this.$route.params.storeId }})
                }
            }
        },
        onFailure(error){
            console.log(error)
        },
        handleSdkInit({ FB, scope }) {
            this.FB = FB
            this.scope = scope
        },
        FBLogin(response){
            console.log(response.authResponse)
            if (response.authResponse) {
                this.FB.api('/me', {locale: 'en_US', fields: 'id,first_name,last_name,email,link,gender,locale,picture'},
                function (response) {
                    console.log(response);
                    component_x.loginUsingFB(response)
                });
            } else {
                console.log('User cancelled login or did not fully authorize.');
            }
        },
        loginUsingFB: async function(res){
            this.errorMessage = null;
            var login_payload = {email: res.email}
            var customer_account = await HTTPRequest.postRequest(this.endPoint + 'sales_channel_customers/login_using_gmail_or_facebook?account_id='+this.storeDetails.account_id, null, login_payload)
            if (customer_account.error){
                this.errorMessage = customer_account.error
                this.loginLoading = false
            } else {
                secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin",customer_account)
                secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerLoginStatus",true)
                secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-fbStatus",true)
                secureStorage.setItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-FB",this.scope)

                this.$notification['info']({
                    message: 'Welcome back ' + customer_account.name+ '!',
                    description: "",
                    style: { zIndex: 100000 }
                });
                this.$emit('checkLoginStatus', event)
                this.loginLoading = false
                if(this.$route.params.returnUrl!=null){
                    this.$router.push({ name: this.$route.params.returnUrl,params:{ storeId:this.$route.params.storeId }})
                }else{
                    this.$router.push({ name: 'store',params:{ storeId:this.$route.params.storeId }})
                }
            }
        }
    }
};
</script>
